/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  display: block;
}
:host .titles {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host .titles .headline {
  margin-right: calc(40rem/14);
  color: #505F6B;
  color: var(--davinci-color-text-light, #505F6B);
  list-style: none;
  font-weight: bold;
  font-size: calc(14rem/14);
  line-height: calc(20rem/14);
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
:host .titles .headline davinci-icon {
  height: calc(18rem/14);
  width: calc(18rem/14);
  -webkit-transform: translateY(-1px);
          transform: translateY(-1px);
  fill: #323c43;
  fill: var(--davinci-color-text, #323c43);
}
:host .titles .headline[selected] {
  border-bottom: calc(3rem/14) var(--davinci-color-primary,#007CC1) solid;
}

:host([type=modern-heavy]) .headline,
:host([type=modern-light]) .headline {
  height: calc(28rem/14);
}
:host([type=modern-heavy]) .headline davinci-icon,
:host([type=modern-light]) .headline davinci-icon {
  margin-right: calc(2rem/14);
  fill: #505F6B;
  fill: var(--davinci-color-text-light, #505F6B);
}
:host([type=modern-heavy]) .headline:hover,
:host([type=modern-light]) .headline:hover {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host([type=modern-heavy]) .headline:hover davinci-icon,
:host([type=modern-light]) .headline:hover davinci-icon {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host([type=modern-heavy]) .headline:focus,
:host([type=modern-light]) .headline:focus {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
:host([type=modern-heavy]) .headline:focus davinci-icon,
:host([type=modern-light]) .headline:focus davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}

:host([type=modern-light]) .headline {
  font-weight: normal;
}
:host([type=modern-light]) .headline[selected] {
  border-bottom: calc(2rem/14) var(--davinci-color-primary,#007CC1) solid;
}

:host([type=classic]) .titles .headline {
  float: left;
  height: calc(47rem/14);
  min-width: calc(120rem/14);
  margin: 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
  background-color: #F0F3F4;
  background-color: var(--davinci-color-background-3, #F0F3F4);
  padding: calc(14rem/14) calc(20rem/14) calc(12rem/14);
  list-style: none;
  font-weight: bold;
  font-size: calc(14rem/14);
  line-height: calc(20rem/14);
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
:host([type=classic]) .titles .headline .title {
  margin: 0px calc(8rem/14);
}
:host([type=classic]) .titles .headline davinci-icon {
  height: calc(20rem/14);
  width: calc(20rem/14);
}
:host([type=classic]) .titles .headline .custom-icon {
  fill: #323c43;
  fill: var(--davinci-color-text, #323c43);
}
:host([type=classic]) .titles .headline .close {
  fill: #B4BEC5;
  fill: var(--davinci-color-outline, #B4BEC5);
  margin-left: auto;
}
:host([type=classic]) .titles .headline .close:hover {
  fill: #FFFFFF;
  fill: var(--davinci-color-white, #FFFFFF);
  background-color: #8999A4;
  background-color: var(--davinci-color-text-disabled, #8999A4);
}
:host([type=classic]) .titles .headline:hover {
  color: #FFFFFF;
  color: var(--davinci-color-white, #FFFFFF);
  background-color: #505F6B;
  background-color: var(--davinci-color-text-light, #505F6B);
}
:host([type=classic]) .titles .headline:hover .custom-icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-white, #FFFFFF);
}
:host([type=classic]) .titles .headline:focus {
  color: #FFFFFF;
  color: var(--davinci-color-white, #FFFFFF);
  background-color: #697987;
  background-color: var(--davinci-color-text-lighter, #697987);
}
:host([type=classic]) .titles .headline[selected] {
  border-top: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
  border-left: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
  border-right: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
  border-bottom: 0;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  color: #505F6B;
  color: var(--davinci-color-text-light, #505F6B);
}
:host([type=classic]) .titles .headline[selected] .custom-icon {
  fill: #323c43;
  fill: var(--davinci-color-text, #323c43);
}
:host([type=classic]) .titles .rest {
  margin: 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid var(--davinci-color-outline,#B4BEC5);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  height: calc(47rem/14);
}

/*
:host([type='classic-small']) {

  .titles {
    .headline {
      float: left;
      min-width: 120px;
      margin: 0;
      @include color(color-background-3, background-color);
      padding: 8px;
      list-style: none;
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
      display: flex;
      justify-content: center;
      align-items: center;

      .title {
        margin: 0px 8px;
      }

      davinci-icon {
        height: 16px;
        width: 16px;
      }
      .custom-icon {
        @include color(color-text, fill);
      }
      .close {
        @include color(color-outline, fill);
        margin-left: auto
      }
      .close:hover {
        @include color(color-white, fill);
        @include color(color-text-disabled, background-color);
      }
    }

    .headline + .headline {
      border-left: 1px solid color(color-outline);
    }

    .headline:hover {
      @include color(color-white, color);
      @include color(color-text-light, background-color);
      davinci-icon {
        @include color(color-white, fill);
      }
    }

    .headline:focus {
      @include color(color-white, color);
      @include color(color-text-lighter, background-color);
      davinci-icon {
        @include color(color-white, fill);
      }
    }

    .headline[selected] {
      border-bottom: 0;
      @include color(color-white, background-color);
      @include color(color-text-light, color);
      davinci-icon {
        @include color(color-outline, fill);
      }
      .custom-icon {
        @include color(color-text, fill);
      }
    }
  }
}
*/`;
export { style };
//# sourceMappingURL=Tabs.style.js.map